const api = {
 baseApi: "https://diskoverapi.jgatenext.com",
  //baseApi: "https://betaapi.jgatenext.com",
}

export default api;